var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "modal-get-price",
        pivotY: 0.2,
        width: 650,
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("modal-get-price")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title-big" }, [
        _vm._v("\n        Узнать цену для своего дома\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cd-modal-grid" }, [
        _c("div", { staticClass: "cd-modal-grid-element" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.extraInput,
                expression: "extraInput"
              }
            ],
            staticClass: "input-absolute",
            attrs: {
              type: "text",
              placeholder: "Введите данные",
              autocomplete: "off"
            },
            domProps: { value: _vm.extraInput },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.extraInput = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "margin-10-0" }, [
            _vm._v("\n                Ваше имя:"),
            _c(
              "span",
              {
                staticClass: "red-text",
                attrs: { title: "Обязательное поле!" }
              },
              [_vm._v("*")]
            )
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.customerName,
                expression: "customerName"
              }
            ],
            staticClass: "cd-modal-text-input",
            attrs: { type: "text", placeholder: "Ваше имя *" },
            domProps: { value: _vm.customerName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.customerName = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAlert === "customerName",
                  expression: "showAlert === 'customerName'"
                }
              ],
              staticClass: "form-alert-danger"
            },
            [_vm._v("\n                Обязательное поле!\n            ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cd-modal-grid-element" }, [
          _c("div", { staticClass: "margin-10-0" }, [
            _vm._v("\n                E-mail:"),
            _c(
              "span",
              {
                staticClass: "red-text",
                attrs: { title: "Обязательное поле!" }
              },
              [_vm._v("*")]
            )
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.customerEmail,
                expression: "customerEmail"
              }
            ],
            staticClass: "cd-modal-text-input",
            attrs: { type: "text", placeholder: "Ваша электронная почта *" },
            domProps: { value: _vm.customerEmail },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.customerEmail = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAlert === "customerEmail",
                  expression: "showAlert === 'customerEmail'"
                }
              ],
              staticClass: "form-alert-danger"
            },
            [_vm._v("\n                Обязательное поле!\n            ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cd-modal-block" }, [
        _c("div", { staticClass: "cd-modal-grid-element margin-10-30" }, [
          _c("div", { staticClass: "margin-10-0" }, [
            _vm._v(
              "\n                Предоставьте вводные данные для расчета объемов материала:"
            ),
            _c(
              "span",
              {
                staticClass: "red-text",
                attrs: { title: "Обязательное поле!" }
              },
              [_vm._v("*")]
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customerComment,
                  expression: "customerComment"
                }
              ],
              staticClass: "cd-modal-text-input modal-textarea",
              attrs: { placeholder: "Что Вас интересует? *" },
              domProps: { value: _vm.customerComment },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.customerComment = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAlert === "customerComment",
                  expression: "showAlert === 'customerComment'"
                }
              ],
              staticClass: "form-alert-danger"
            },
            [_vm._v("\n                Обязательное поле!\n            ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cd-modal-grid add-padding" }, [
        _c("div", [
          _c("div", { staticClass: "pretty p-default" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.IAgree,
                  expression: "IAgree"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.IAgree)
                  ? _vm._i(_vm.IAgree, null) > -1
                  : _vm.IAgree
              },
              on: {
                change: function($event) {
                  var $$a = _vm.IAgree,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.IAgree = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.IAgree = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.IAgree = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "state p-danger" }, [_c("label")])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            '\n            Я даю своё согласие на обработку моих персональных данных в соответствии с Федеральным законом от 27.07.2006 года №152-Ф3 "О персональных данных" на условиях, определённых в\n            '
          ),
          _c(
            "a",
            {
              staticClass: "red-text",
              staticStyle: { "text-decoration": "none" },
              attrs: {
                href:
                  "https://www.grandline.ru/politika-zashity-i-obrabotki-personalnyh-dannyh/",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n                Согласии на обработку персональных данных\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-alert-grid margin-30" }, [
        _c(
          "div",
          {
            staticClass: "gl-square-btn btn-grey",
            on: { click: _vm.submitSend }
          },
          [_vm._v("\n            Отправить\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showAlert === "IAgree",
                expression: "showAlert === 'IAgree'"
              }
            ],
            staticClass: "form-alert-danger-agreement"
          },
          [
            _vm._v(
              "\n            Подтвердите согласие на обработку персональных данных!\n        "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }